document.addEventListener('DOMContentLoaded', function() {
    const targetElement = document.querySelector('.announcement-bar '); 

    window.addEventListener('scroll', () => {
    const scrollPosition = window.pageYOffset || document.documentElement.scrollTop;

    if (scrollPosition > 1) {
        targetElement.classList.add('announcement-bar-is-scrolled');
    } else {
        targetElement.classList.remove('announcement-bar-is-scrolled');
    }
    });

})

